/**
 * Safely parse JSON string to object or null
 * @param parseString
 */
const safelyParseJson = (parseString) => {
    try {
        return JSON.parse(parseString);
    }
    catch (e) {
        return null;
    }
};
export default safelyParseJson;
